const PLUGIN_NAME = 'access-code';

export { PLUGIN_NAME };
